import { Grid, Box } from '@material-ui/core';
import React, { useContext, useState } from 'react';
import SubquestionBox from '../SubquestionBox';
import Filters from './Filters';
import FiltersContext from '../../contexts/FiltersContext';
import PercentOfPriceAndPercentOfMedianIncome from './PercentOfPriceAndPercentOfMedianIncome';
import StateStats from './StateStats';
import StoryContext from '../../contexts/StoryContext';
import ErrorBoundary from '../ErrorBoundary';

function Q1Row1() {
  const [familyType, setFamilyType] = useState('All');
  const [settingType, setSettingType] = useState('All');
  const [childAge, setChildAge] = useState('All');

  const { lightColor } = useContext(StoryContext);

  return (
    <FiltersContext.Provider value={{
      familyType, setFamilyType, settingType, setSettingType, childAge, setChildAge,
    }}
    >
      <SubquestionBox color={lightColor}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box displayPrint="none">
              <Filters />
            </Box>
          </Grid>
          <Grid item xs={12} sm={6}>
            <ErrorBoundary>
              <StateStats />
            </ErrorBoundary>
          </Grid>
          <Grid item xs={12} sm={6}>
            <ErrorBoundary>
              <PercentOfPriceAndPercentOfMedianIncome />
            </ErrorBoundary>
          </Grid>
        </Grid>
      </SubquestionBox>
    </FiltersContext.Provider>
  );
}

export default Q1Row1;
